import module from 'finanzas/module.js'
import template from './template.html'

export class CargaMovimientosBancariosHistorialDetalladoComponent {
  loteId
  titulo
  subtitulo
  capturaUsuario
  capturaFecha
  onClose

  constructor (FinancesCargarMovimientosBancariosHistorialDetallado) {
    this.FinancesCargarMovimientosBancariosHistorialDetalladoService = FinancesCargarMovimientosBancariosHistorialDetallado
  }

  $onInit () {
    this.promise = this.FinancesCargarMovimientosBancariosHistorialDetalladoService.get(this.loteId)
      .then((response) => (this.data = response.data))
  }

  cerrar () {
    this.onClose()
  }
}

module.component('financesCargamovimientosbancariosHistorialDetallado', {
  controller: CargaMovimientosBancariosHistorialDetalladoComponent,
  template,
  bindings: {
    loteId: '<',
    titulo: '<',
    subtitulo: '<',
    capturaUsuario: '<',
    capturaFecha: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/historial/detallado/component.js